import type { Component, JSX } from "solid-js";
import { For } from "solid-js";

type SimpleTableProps = {
  data: { label: string; value: JSX.Element }[];
};

const SimpleTable: Component<SimpleTableProps> = (props) => (
  <div class="overflow-hidden rounded-sm border border-subtle">
    <table class="w-full">
      <tbody class="divide-y divide-subtle text-left align-top">
        <For each={props.data}>
          {({ label, value }) => (
            <tr class="divide-x divide-subtle wrap-anywhere">
              <th scope="row" class="w-46 bg-surface-extra-subtle px-3 py-2 text-base-medium text-primary">
                {label}
              </th>
              <td class="px-3 py-2 text-base-regular text-secondary">{value}</td>
            </tr>
          )}
        </For>
      </tbody>
    </table>
  </div>
);

export default SimpleTable;
